import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useServices } from "@website/widget/header";
export function TravelServicesDesktop() {
  const $ = _c(5);
  const {
    services
  } = useServices();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button className="!mx-0" EndIcon={<MaterialIcon name="keyboard_arrow_down" />} aria-label={"\u062E\u062F\u0645\u0627\u062A \u0645\u0633\u0627\u0641\u0631\u062A\u06CC"} color="neutral" size="medium" variant="text">خدمات مسافرتی</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== services) {
    t1 = services.map(_temp);
    $[1] = services;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="group relative hidden h-full items-center lg:flex">{t0}<section className="pointer-events-none invisible absolute top-0 z-50 size-auto translate-y-20 py-1 opacity-0 transition-all duration-75 ease-in-out group-hover:pointer-events-auto group-hover:visible group-hover:top-[56px] group-hover:translate-y-2 group-hover:opacity-100"><div className="elevation-8 size-auto rounded-lg"><div className="w-[280px] rounded-lg p-2">{t1}</div></div></section></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(item) {
  return <a className="hover:bg-states-neutral-hover flex h-12 items-center justify-start gap-2 rounded-lg px-1 transition-all" href={item.url} key={item.title} {...item.nofollow && {
    rel: "nofollow"
  }}><span className="text-on-surface-medium-emphasis text-2xl">{item.icon}</span><div className="text-button text-on-surface-high-emphasis">{item.title}</div></a>;
}